import { IContent } from "@vmosolutions/oc-interfaces";
import { useEffect, useState } from "react";
import { Box, styled } from "@mui/material";
import { useFileContents } from "src/pages/contentViewers/useFileContents";
import { ViewerShell } from "src/pages/contentViewers/ViewerShell";

interface IImageViewerProps {
  windowProps: {
    file: IContent;
  };
}

const ImageBox = styled(Box)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  overflow: "auto",
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.default,
  "& img": {
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain",
  },
}));

export function ImageViewerWindow(props: IImageViewerProps): JSX.Element {
  const { file } = props.windowProps;
  const { url, loading, error } = useFileContents(file, "url");
  const [imgLoaded, setImgLoaded] = useState<boolean>(false);
  const [imgError, setImgError] = useState<boolean>(false);

  // Reset the per-image load state whenever the underlying URL changes.
  useEffect(() => {
    setImgLoaded(false);
    setImgError(false);
  }, [url]);

  return (
    <ViewerShell file={file} loading={loading || (!!url && !imgLoaded && !imgError)} error={error || imgError}>
      <ImageBox>
        {url && (
          <Box
            component="img"
            src={url}
            alt={file.displayTitle ?? file.fileName}
            onLoad={() => setImgLoaded(true)}
            onError={() => setImgError(true)}
          />
        )}
      </ImageBox>
    </ViewerShell>
  );
}
